import React, { useEffect } from "react";
import { Container } from "@material-ui/core";
import SMAButton from "../../shared/Button/Button";
import { makeStyles } from "@material-ui/core/styles";
import themeDark from "../../shared/themeDark";
import { ROUTE_STATES, EVENT_SHIFT_STATUS } from "./types";
import api from "../../../store/api";

const useStyles = makeStyles({
  buttonsGroup: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    marginTop: "29px",
  },
  button: {
    margin: "0 10px",
  },
  bodyContainer: {},
});

const ButtonsNav = ({ shiftState, changeShiftState }: any) => {
  const classes = useStyles(themeDark);

  let routeState = ROUTE_STATES.EN_ROUTE_TO_SITE;

  switch (shiftState) {
    case EVENT_SHIFT_STATUS.EnRouteToSite:
      routeState = ROUTE_STATES.EN_ROUTE_TO_SITE;      
      break;
    case EVENT_SHIFT_STATUS.OnSite:
      routeState = ROUTE_STATES.ON_SITE;
      break;
    case EVENT_SHIFT_STATUS.EventComplete:
      routeState = ROUTE_STATES.EVENT_COMPLETE;
      break;
    case EVENT_SHIFT_STATUS.EnRouteBack:
      routeState = ROUTE_STATES.EN_ROUTE_BACK;
      break;
    case EVENT_SHIFT_STATUS.ArrivedBack:
      routeState = ROUTE_STATES.ARRIVED_BACK;
      break;
    default:
      routeState = ROUTE_STATES.EN_ROUTE_TO_SITE;
  }

  return (
    <Container className={classes.buttonsGroup}>
      <SMAButton
        className={classes.button}
        disabled={routeState.button1.disabled}
        color={routeState.button1.color}
        variant="contained"
        onAction={() => {
          changeShiftState(EVENT_SHIFT_STATUS.EnRouteToSite);
        }}
      >
        En Route to Site
      </SMAButton>
      <SMAButton
        className={classes.button}
        disabled={routeState.button2.disabled}
        color={routeState.button2.color}
        variant="contained"
        onAction={() => {
          changeShiftState(EVENT_SHIFT_STATUS.OnSite);
        }}
      >
        On Site
      </SMAButton>
      <SMAButton
        className={classes.button}
        disabled={routeState.button3.disabled}
        color={routeState.button3.color}
        variant="contained"
        onAction={() => {
          changeShiftState(EVENT_SHIFT_STATUS.EventComplete);
        }}
      >
        Event Complete
      </SMAButton>
      <SMAButton
        className={classes.button}
        disabled={routeState.button4.disabled}
        color={routeState.button4.color}
        variant="contained"
        onAction={() => {
          changeShiftState(EVENT_SHIFT_STATUS.EnRouteBack);
        }}
      >
        En Route Back
      </SMAButton>
      <SMAButton
        className={classes.button}
        disabled={routeState.button5.disabled}
        color={routeState.button5.color}
        variant="contained"
        onAction={() => {
          changeShiftState(EVENT_SHIFT_STATUS.ArrivedBack);
        }}
      >
        Arrived Back
      </SMAButton>
    </Container>
  );
};

export default ButtonsNav;
